import styled from 'styled-components/macro'

const BasicNemesisCardGridWrapper = styled('div')`
  margin-top: 24px;
  width: 100%;
`

export default BasicNemesisCardGridWrapper
